// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null
}

const mooc = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_MOOC':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }

    case 'GET_DATA_MOOC_ADMIN':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }

    default:
      return { ...state }
  }
}

export default mooc
